export default __webpack_public_path__ + "static/media/ic_glp_custom.cb1ab28b.svg";